<template>
  <router-link :to="to" :class="['inner-link', {
    'inner-link_secondary': color === 'secondary'
  }]">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  props: {
    to: String,
    color: {
      type: String,
      default: 'primary'
    }
  }
}
</script>

<style scoped>
.inner-link {
  display: block;
  width: max-content;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: var(--primary-color);
  opacity: 1;
  transition: opacity 0.15s ease-out
}

.inner-link:hover {
  opacity: 0.75;
}

.inner-link_secondary {
  color: var(--secondary-color);
}
</style>

